// Import jQuery
import $ from 'jquery';

// Function to toggle modal visibility
const toggleModal = (buttonSelector, modalSelector, contentSelector, videoSrc) => {
  $(buttonSelector).click(function () {
    $('body').toggleClass('overflow-hidden w-full h-full');
    $(modalSelector).toggleClass('hidden');

    // Hide all video contents first
    $('[id^="video-content"]').hide();

    // Show the specific video content associated with contentSelector
    $(contentSelector).show();

    // Nastavíme src pro iframe s videem v aktuálním contentSelectoru
    const iframe = $(contentSelector).find('iframe');
    iframe.attr('src', videoSrc); // Nastavení src z data-video-src
  });
};

// Map buttons to their respective modals, content, and video src
const mapping = {
  '#video-oz': { modal: '#modal', content: '#video-content-oz', videoSrc: 'https://www.youtube.com/embed/Do72TXOD21w?si=WIJIaYdscJHhTU14' },
  '#video-1': { modal: '#modal', content: '#video-content-1', videoSrc: 'https://www.youtube.com/embed/nZ-I464vCso?si=yQscttiVmQjFYxT3' },
  '#video-2': { modal: '#modal', content: '#video-content-2', videoSrc: 'https://www.youtube.com/embed/orp8eN1_Ztw' },
  '#video-3': { modal: '#modal', content: '#video-content-3', videoSrc: 'https://www.youtube.com/embed/f4appNlsydc?si=t00fWInYk--Q2rUV' },
  '#video-4': { modal: '#modal', content: '#video-content-4', videoSrc: 'https://www.youtube.com/embed/-i1rh9JF-A8?si=Li5aAuNFjOJrHtUK' },
  '#video-f1': { modal: '#modal', content: '#video-content-f1', videoSrc: 'https://www.youtube.com/embed/-i1rh9JF-A8?si=LKe49s5tmTxwJt_E&start=72' },
  '#video-f2': { modal: '#modal', content: '#video-content-f2', videoSrc: 'https://www.youtube.com/embed/PzC3C3usaaE?si=X5ICmpNCvDyn1Ngp' },
  '#video-f3': { modal: '#modal', content: '#video-content-f3', videoSrc: 'https://www.youtube.com/embed/sCLybIAV4K8?si=NYf87_AsmReHLitE' },
  '#video-f4': { modal: '#modal', content: '#video-content-f4', videoSrc: 'https://www.youtube.com/embed/4y5JkPzWezs' },
  // Add more mappings as needed
};

// Attach click events to buttons based on the mapping
for (let button in mapping) {
  const { modal, content, videoSrc } = mapping[button];
  toggleModal(button, modal, content, videoSrc);
}

// Zavírání modalu a zastavení přehrávání videa
$('#modal-close').click(function() {
  $('body').removeClass('overflow-hidden w-full h-full');
  $('#modal').addClass('hidden');

  // Zastavení přehrávání videa pro aktuálně zobrazené video
  $('[id^="video-content"] iframe').each(function() {
    $(this).attr('src', ''); // Nastavení src na prázdný řetězec, aby se zastavilo přehrávání
  });
});

// Function to get the percentage of an element's visibility
function getVisibilityPercent(element) {
  const rect = element.getBoundingClientRect();
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

  // Check if the element is completely out of view
  if (rect.bottom < 0 || rect.top > windowHeight || rect.right < 0 || rect.left > windowWidth) {
    return 0;
  }

  // Calculate visible area
  const heightVisible = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
  const widthVisible = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
  const areaVisible = heightVisible * widthVisible;
  const totalArea = rect.width * rect.height;

  // Return visibility percentage
  return (areaVisible / totalArea) * 100;
}

// Function to check visibility on scroll
function checkScroll() {
  const el = document.getElementById('show-extra');
  const footer = document.getElementById('footer');

  if (el) {
    if (getVisibilityPercent(el) >= 30) {
      document.body.classList.add('bg-blue');
    } else {
      document.body.classList.remove('bg-blue'); // Remove this line if you want the class to persist
    }
  }

  if (footer) {
    if (getVisibilityPercent(footer) > 0) {
      document.body.classList.remove('bg-gradient-to-tr', 'from-[#ffffff]', 'via-[#facb7466]', 'to-[#ffc864]');
    } else {
      document.body.classList.add('bg-gradient-to-tr', 'from-[#ffffff]', 'via-[#facb7466]', 'to-[#ffc864]');
    }
  }
}

// Attach scroll event listener
window.addEventListener('scroll', checkScroll);

// Initial check in case elements are already in view on page load
checkScroll();


// Example usage of toggleModal for different buttons and modals
const additionalMapping = {
  '.offer-btn': '#offer',
  '#offer-close': '#offer',
};

// Attach click events for additional modals
for (let button in additionalMapping) {
  toggleModal(button, additionalMapping[button]);
}


let modalShown = false;
function showModal() {
    if (!modalShown) {
        document.getElementById('exitIntent').classList.remove('hidden');
        modalShown = true;
    }
}

function closeModal() {
    document.getElementById('exitIntent').classList.add('hidden');
}

const exitIntentCloseButton = document.getElementById('exitIntent-close');
if (exitIntentCloseButton) {
    exitIntentCloseButton.addEventListener('click', closeModal);
}
document.addEventListener('mouseout', function(event) {
    if (event.clientY <= 0) {
        showModal();
    }
});